import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { BLOG_POSTS } from "@/data/blog";

const BlogIndexPage = () => {
  const { t } = useTranslation();

  const schema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Conseils nettoyage -BIONET SOLUTIONS",
    blogPost: BLOG_POSTS.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      datePublished: p.date,
      url: `https://bionet-solutions.com/blog/${p.slug}`,
    })),
  };

  return (
    <>
      <Seo titleKey="seo.blog_title" descKey="seo.blog_desc" path="/blog" schema={schema} />
      <section className="container-x pt-14 pb-10">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">{t("nav.blog")}</p>
        <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-slate-900">
          {t("blog.title")}
        </h1>
        <p className="mt-4 text-slate-600 text-base sm:text-lg max-w-3xl leading-relaxed">
          {t("blog.subtitle")}
        </p>
      </section>

      <section className="container-x pb-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {BLOG_POSTS.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            className="group rounded-3xl bg-white border border-slate-200 ring-soft overflow-hidden hover:-translate-y-1 transition"
            data-testid={`blog-card-${p.slug}`}
          >
            <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
              <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" loading="lazy" />
              <div className="absolute top-3 left-3 pill !bg-white !text-slate-700">
                <span>{p.category}</span>
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 text-xs text-slate-500">
                <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {new Date(p.date).toLocaleDateString("fr-FR")}</span>
                <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {p.read_time}</span>
              </div>
              <h2 className="mt-3 font-heading font-bold text-lg text-slate-900 leading-snug">
                {p.title}
              </h2>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{p.description}</p>
              <div className="mt-4 inline-flex items-center text-sm font-semibold text-brand-green">
                {t("blog.read_more")} <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-0.5 transition" />
              </div>
            </div>
          </Link>
        ))}
      </section>
    </>
  );
};

export default BlogIndexPage;
